import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

import type {SignoffSerializedType} from 'sweet-types';

type Props = {
  signoff?: SignoffSerializedType | null;
};

export const DocUnsignedBadge = ({signoff}: Props) => {
  if (signoff == null || signoff.signed_at != null) {
    return null;
  }

  return (
    <LazyTooltip tooltip={gt('Document requires your signature')}>
      <span className="ml-1 badge badge-warning">
        <i className="fa fa-signature" /> {gt('Unsigned')}
      </span>
    </LazyTooltip>
  );
};
